import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import ModalQuestion from './ModalQuestion';
import Input from '../input/Input';
import { validarEmail } from '../../../helper/Validar';

class ModalQuestionEmail extends AbstractComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            value: '',
            erro:''
        }
    }     

    validarEmail() {
        this.setState({erro: ''});

        if(!validarEmail(this.state.value)) {
            this.setState({erro: 'Email inválido'});

            return;
        }

        this.props.acao(this.state.value);

        this.setState({value: ''});
    }       

    render() {
        return (
            <ModalQuestion
                show={this.props.show}                
                header="Teste de envio do e-mail"

                buttonSimTxt="Enviar"
                buttonNaoTxt="Cancelar"                
                
                fechar={() => this.props.fechar() }
                btnSimClick={ () => this.validarEmail() }
                btnNaoClick={ () => this.props.fechar() }
            >
                <Input
                    Style={{float: 'left'}}
                    md={12}
                    xs={12}
                    sm={12}
                    lg={12}
                    id="email"
                    nome="email"
                    value={this.state.value}
                    defaultValue={this.state.value}
                    defaultFoco={true}
                    erro={this.state.erro}
                    onChange={(e) => this.setState({ value:  e.target.value})}
                >
                    Informe o destinatário
                </Input>
            </ModalQuestion>            
        )
    }
}

export default ModalQuestionEmail;